import { render, staticRenderFns } from "./RenameFamiliaModal.vue?vue&type=template&id=0fd20761"
import script from "./RenameFamiliaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameFamiliaModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports